import type { Species } from './types';

export interface Breed {
  id: string;
  name: string;
}

// Full Fetch breed list (source: Fetch "Breed List" — DOGBreed + CATBreed sheets).
const DOG: Breed[] = [
  { id: '3JQT5U07', name: 'Affenpinscher' },
  { id: '3JQT5U08', name: 'Afghan Hound' },
  { id: '3JQT5U09', name: 'Aidi' },
  { id: '3JQT5U15', name: 'Ainu Dog' },
  { id: 'MIXAIRED', name: 'Airedale Mix' },
  { id: '3JQT5U16', name: 'Airedale Terrier' },
  { id: '3JQT5U17', name: 'Akbash Dog' },
  { id: '3JQT5U18', name: 'Akita' },
  { id: 'MIXAKITA', name: 'Akita Mix' },
  { id: '3JQT5U19', name: 'Alano Espanol' },
  { id: '3JQT5U25', name: 'Alapaha Blue Blood Bulldog' },
  { id: '3JQT5U26', name: 'Alaskan Husky' },
  { id: '3JQT5U27', name: 'Alaskan Klee Kai' },
  { id: '3JQT5U28', name: 'Alaskan Malamute' },
  { id: '3JQT5U29', name: 'Alpine Dachsbracke' },
  { id: '3JQT5U35', name: 'Alsatian' },
  { id: '3JQT5U36', name: 'American Bulldog' },
  { id: '3JQT5U37', name: 'American Bullnese' },
  { id: 'AMNBULLY', name: 'American Bully' },
  { id: '3JQT5U38', name: 'American Cocker Spaniel' },
  { id: '3JQT5U39', name: 'American Eskimo Dog' },
  { id: '3JQT5U45', name: 'American Eskimo Dog - miniature' },
  { id: 'MIXAMERE', name: 'American Eskimo Mix' },
  { id: '3JQT5U46', name: 'American Foxhound' },
  { id: '3JQT5U47', name: 'American Hairless Terrier' },
  { id: 'AMERICIN', name: 'American Indian Dog' },
  { id: '3JQT5U48', name: 'American Lo-Sze Pugg' },
  { id: '3JQT5U49', name: 'American Mastiff' },
  { id: '3JQT5U55', name: 'American Pit Bull Terrier' },
  { id: '3JQT5U56', name: 'American Staffordshire Terrier' },
  { id: 'MIXAMERS', name: 'American Staffordshire Terrier Mix' },
  { id: '3JQT5U57', name: 'American Staghound' },
  { id: '3JQT5U58', name: 'American Tundra Shepherd' },
  { id: '3JQT5U59', name: 'American Water Spaniel' },
  { id: '3JQT5U75', name: 'American White Shepherd' },
  { id: '3JQT5U76', name: 'Anatolian Shepherd Dog' },
  { id: '3JQT5U77', name: 'Appenzell Mountain Dog' },
  { id: 'APNZSNNH', name: 'Appenzeller Sennenhund' },
  { id: '3JQT5U78', name: 'Argentine Dogo' },
  { id: '3KKU0BA9', name: 'Ariegoeis' },
  { id: '3JQT5U79', name: 'Australian Cattle Dog' },
  { id: 'MIXAUSTC', name: 'Australian Cattle Dog Mix' },
  { id: '3JQT5U85', name: 'Australian Kelpie' },
  { id: '3JQT5U86', name: 'Australian Shepherd' },
  { id: '3JQT5U87', name: 'Australian Shepherd - miniature' },
  { id: 'MIXAUSTS', name: 'Australian Shepherd Mix' },
  { id: '3JQT5U88', name: 'Australian Terrier' },
  { id: '3JQT5U89', name: 'Austrian Brandlbracke' },
  { id: '3JQT5U95', name: 'Austrian Shorthaired Pinscher' },
  { id: '3JQT5U96', name: 'Azawakh' },
  { id: '3JQT5U97', name: 'Barbet' },
  { id: '3JQT5U98', name: 'Basenji' },
  { id: '3JQT5U99', name: 'Basset Artesien Normand' },
  { id: '3JQT5UA5', name: 'Basset Bleu De Gascogne' },
  { id: '3JQT5UA6', name: 'Basset Fauve De Bretagne' },
  { id: '3JQT5UA7', name: 'Basset Hound' },
  { id: 'MIXBASSE', name: 'Basset Hound Mix' },
  { id: '3JQT5UA8', name: 'Beagle' },
  { id: 'MIXBEAGL', name: 'Beagle Mix' },
  { id: '3JQT5UA9', name: 'Bearded Collie' },
  { id: '3JQT5UB5', name: 'Beauceron' },
  { id: '3JQT5UB6', name: 'Bedlington Terrier' },
  { id: '3JQT5UB7', name: 'Belgian Shepherd Groenendael' },
  { id: '3JQT5UB8', name: 'Belgian Shepherd Laekenois' },
  { id: '3JQT5UB9', name: 'Belgian Shepherd Malinois' },
  { id: 'MIXBELGI', name: 'Belgian Shepherd Mix' },
  { id: '3JQT5UC5', name: 'Belgian Shepherd Tervuren' },
  { id: '3JQT5UC6', name: 'Bergamasco' },
  { id: 'BRGBLCSW', name: 'Berger Blanc Swiss' },
  { id: '3JQT5UC8', name: 'Berger des Pyrenees' },
  { id: '3JQT5UC7', name: 'Berger Picard' },
  { id: '3JQT5UC9', name: 'Bernese Mountain Dog' },
  { id: 'MIXBERNE', name: 'Bernese Mountain Dog Mix' },
  { id: '3JQT5UD5', name: 'Bichon Frise' },
  { id: 'MIXBICHO', name: 'Bichon Frise Mix' },
  { id: '3JQT5UD6', name: 'Biewer' },
  { id: '3JQT5UD7', name: 'Black Mouth Cur' },
  { id: '3JQT5UD8', name: 'Black Russian Terrier' },
  { id: '3JQT5UD9', name: 'Bloodhound' },
  { id: '3JQT5UF5', name: 'Blue Heeler' },
  { id: '3JQT5UF6', name: 'Blue Lacy' },
  { id: '3JQT5UF7', name: 'Bluetick Coonhound' },
  { id: '3JQT5UF8', name: 'Boerboel' },
  { id: '3JQT5UF9', name: 'Bolognese' },
  { id: 'BOLONKA1', name: 'Bolonka' },
  { id: '3JQT5UG5', name: 'Border Collie' },
  { id: 'MIXBORDE', name: 'Border Collie Mix' },
  { id: '3JQT5UG6', name: 'Border Terrier' },
  { id: '3JQT5UG7', name: 'Borzoi' },
  { id: 'Bosnian', name: 'Bosnian Coarse Haired Hound' },
  { id: '3JQT5UG8', name: 'Boston Terrier' },
  { id: 'MIXBOSTO', name: 'Boston Terrier Mix' },
  { id: '3JQT5UG9', name: 'Bouvier Des Flandres' },
  { id: 'MIXBOUVI', name: 'Bouvier Des Flandres Mix' },
  { id: '3JQT5UH5', name: 'Boxer' },
  { id: 'MIXBOXER', name: 'Boxer Mix' },
  { id: '3JQT5UH6', name: 'Boykin Spaniel' },
  { id: '3JQT5UH7', name: 'Bracco Italiano' },
  { id: 'BraqueA', name: 'Braque d Auvergne' },
  { id: 'BraqueB', name: 'Braque du Bourbonnais' },
  { id: 'BRAQFRAN', name: 'Braque Francais' },
  { id: '3JQT5UH8', name: 'Brazilian Fila' },
  { id: '3JQT5UH9', name: 'Brazilian Terrier' },
  { id: '3JQT5UI5', name: 'Briard' },
  { id: '3JQT5UI6', name: 'Briquet Griffon Vendeen' },
  { id: '3JQT5UI7', name: 'Brittany' },
  { id: 'MIXBRITT', name: 'Brittany Mix' },
  { id: '3JQT5UI8', name: 'Brussels Griffon' },
  { id: 'MIXBRUSS', name: 'Brussels Griffon Mix' },
  { id: '3JQT5UI9', name: 'Bull Terrier' },
  { id: '3JQT5UJ5', name: 'Bull Terrier - miniature' },
  { id: '3JQT5UJ6', name: 'BullBoxer' },
  { id: '3JQT5UJ7', name: 'Bulldog' },
  { id: 'MIXBULLD', name: 'Bulldog Mix' },
  { id: '3JQT5UJ8', name: 'Bullmastiff' },
  { id: 'MIXBULLM', name: 'Bullmastiff Mix' },
  { id: '3JQT5UJ9', name: 'Ca de Bou' },
  { id: '3JQT5UK5', name: 'Cairn Terrier' },
  { id: 'MIXCAIRN', name: 'Cairn Terrier Mix' },
  { id: '3JQT5UK6', name: 'Canaan Dog' },
  { id: '3JQT5UK7', name: 'Canadian Eskimo Dog' },
  { id: '3JQT5UK8', name: 'Canary Dog' },
  { id: '3JQT5UK9', name: 'Cane Corso' },
  { id: '3JQT5UM5', name: 'Cao de Fila de Sao Miguel' },
  { id: '3JQT5UM6', name: 'Cardigan Welsh Corgi' },
  { id: '3JQT5UM7', name: 'Carolina Dog' },
  { id: '3JQT5UM8', name: 'Catahoula Leopard Dog' },
  { id: 'CTLNSHPD', name: 'Catalan Sheepdogs' },
  { id: '3JQT5UM9', name: 'Caucasian Ovtcharka' },
  { id: '3JQT5UN5', name: 'Cavachon' },
  { id: '3JQT5UN6', name: 'Cavalier King Charles Spaniel' },
  { id: 'MIXCAVAL', name: 'Cavalier King Charles Spaniel Mix' },
  { id: '3JQT5UN7', name: 'Central Asian Ovtcharka' },
  { id: '3JQT5UN8', name: 'Cesky Fousek' },
  { id: '3JQT5UN9', name: 'Cesky Terrier' },
  { id: 'CHASA', name: 'Chasa Apso' },
  { id: '3JQT5UO5', name: 'Chesapeake Bay Retriever' },
  { id: '3JQT5UO6', name: 'Chien D Artois' },
  { id: '3JQT5UO7', name: 'Chihuahua' },
  { id: '3JQT5UO8', name: 'Chihuahua long-haired' },
  { id: 'MIXCHIHU', name: 'Chihuahua Mix' },
  { id: '3JQT5UO9', name: 'Chinese Chongqing Dog' },
  { id: '3L2QV0T5', name: 'Chinese Crested Dog' },
  { id: '3JQT5UP5', name: 'Chinese Crested Hairless' },
  { id: '3JQT5UP6', name: 'Chinese Crested Powder Puff' },
  { id: 'ChinFoo', name: 'Chinese Foo' },
  { id: 'CHIIMP', name: 'Chinese Imperial' },
  { id: '3JQT5UP7', name: 'Chinook' },
  { id: '3JQT5UP8', name: 'Chow Chow' },
  { id: 'MIXCHOW', name: 'Chow Chow Mix' },
  { id: '3JQT5UP9', name: 'Cirneco dell Etna' },
  { id: '3JQT5UQ5', name: 'Clumber Spaniel' },
  { id: '3JQT5UQ6', name: 'Cockapoo' },
  { id: '3JQT5UQ7', name: 'Cocker Spaniel' },
  { id: '3JQT5UQ8', name: 'Cocker Spaniel Miniature' },
  { id: 'MIXCOCKE', name: 'Cocker Spaniel Mix' },
  { id: '3JQT5UQ9', name: 'Collie' },
  { id: 'MIXCOLLI', name: 'Collie Mix' },
  { id: '3JQT5UR5', name: 'Collie smooth-coated' },
  { id: '3JQT5UR6', name: 'Coonhound - black and tan' },
  { id: '3JQT5UR7', name: 'Coonhound - blue tick' },
  { id: '3JQT5UR8', name: 'Coonhound - red bone' },
  { id: '3JQT5UR9', name: 'Corgi' },
  { id: 'MIXCORGI', name: 'Corgi Mix' },
  { id: '3JQT5UT5', name: 'Coton De Tulear' },
  { id: 'MIXCOTON', name: 'Coton De Tulear Mix' },
  { id: '3JQT5UT6', name: 'Curly-Coated Retriever' },
  { id: 'CZEHWOLF', name: 'Czechoslovakian Wolfdog (Vlcak)' },
  { id: '3KVVHL20', name: 'Dachshund' },
  { id: '3JQT5UT7', name: 'Dachshund - long haired' },
  { id: 'MIXDACHS', name: 'Dachshund Mix' },
  { id: '3JQT5UT8', name: 'Dachshund - smooth coat' },
  { id: '3JQT5UT9', name: 'Dachshund - wire haired' },
  { id: '3JQT5UU5', name: 'Dachshund miniature - long haired' },
  { id: '3JQT5UU6', name: 'Dachshund miniature - smooth coat' },
  { id: '3JQT5UU7', name: 'Dachshund miniature - wire haired' },
  { id: '3JQT5UU8', name: 'Dalmatian' },
  { id: '3L2QUS19', name: 'Dalmatian Mix' },
  { id: '3JQT5UU9', name: 'Dandie Dinmont Terrier' },
  { id: '3JQT5UV5', name: 'Danish-Swedish Farmdog' },
  { id: '3JQT5UV6', name: 'Deerhound' },
  { id: 'DEUTDRAH', name: 'Deutsch Drahthaar' },
  { id: '3JQT5UV7', name: 'Deutscher Wachtelhund' },
  { id: '3JQT5UV8', name: 'Doberman Pinscher' },
  { id: 'MIXDOBER', name: 'Doberman Pinscher Mix' },
  { id: '3JQT5UV9', name: 'Dogo Argentino' },
  { id: '3JQT5V05', name: 'Dogue De Bordeaux' },
  { id: '3JQT5V06', name: 'Dorgie' },
  { id: '3JQT5V07', name: 'Drever' },
  { id: '3JQT5V08', name: 'Dunker' },
  { id: '3JQT5V09', name: 'Dutch Sheepdog' },
  { id: 'DUTCHSHE', name: 'Dutch Shepherd' },
  { id: '3JQT5V15', name: 'Dutch Smoushond' },
  { id: '3JQT5V16', name: 'Elkhound' },
  { id: '3JQT5V17', name: 'English Bulldog' },
  { id: '3JQT5V18', name: 'English Cocker Spaniel' },
  { id: 'MIXENGCO', name: 'English Cocker Spaniel Mix' },
  { id: '3JQT5V19', name: 'English Coonhound' },
  { id: '3JQT5V25', name: 'English Foxhound' },
  { id: '3JQT5V26', name: 'English Mastiff' },
  { id: 'MIXENGMA', name: 'English Mastiff Mix' },
  { id: '3JQT5V27', name: 'English Pointer' },
  { id: '3JQT5V28', name: 'English Setter' },
  { id: 'MIXENGSE', name: 'English Setter Mix' },
  { id: '3JQT5V29', name: 'English Shepherd' },
  { id: '3JQT5V35', name: 'English Springer Spaniel' },
  { id: 'MIXENGSP', name: 'English Springer Spaniel Mix' },
  { id: '3JQT5V36', name: 'English Toy Spaniel' },
  { id: '3JQT5V37', name: 'English Toy Terrier' },
  { id: '3JQT5V38', name: 'Entlebucher Mountain Dog' },
  { id: '3JQT5V39', name: 'Eskimo Dog' },
  { id: '3KM5IM11', name: 'Estonian Hound' },
  { id: '3JQT5V55', name: 'Estrela Mountain Dog' },
  { id: '3JQT5V56', name: 'Eurasier' },
  { id: '3JQT5V57', name: 'Fell Terrier' },
  { id: '3JQT5V58', name: 'Field Spaniel' },
  { id: '3JQT5V59', name: 'Fila Brasileiro' },
  { id: '3JQT5V65', name: 'Finnish Hound' },
  { id: '3JQT5V66', name: 'Finnish Lapphund' },
  { id: '3JQT5V67', name: 'Finnish Spitz' },
  { id: '3JQT5V68', name: 'Flat-coated Retriever' },
  { id: 'FORMOSMD', name: 'Formosan Mountain Dog' },
  { id: '3JQT5V69', name: 'Fox Hound' },
  { id: '3JQT5V75', name: 'Fox Terrier' },
  { id: '3JQT5V76', name: 'French Bulldog' },
  { id: 'MIXFRENC', name: 'French Bulldog Mix' },
  { id: '3JQT5V77', name: 'French Mastiff' },
  { id: '3JQT5V78', name: 'French Spaniel' },
  { id: '3JQT5V79', name: 'Gazelle Hound' },
  { id: '3JQT5V85', name: 'German Longhaired Pointer' },
  { id: '3JQT5V86', name: 'German Pinscher' },
  { id: '3JQT5V87', name: 'German Shepherd' },
  { id: 'MIXGERSH', name: 'German Shepherd Mix' },
  { id: '3JQT5V88', name: 'German Shorthaired Pointer' },
  { id: 'MIXGERPO', name: 'German Shorthaired Pointer Mix' },
  { id: '3JQT5V89', name: 'German Spitz' },
  { id: '3JQT5V95', name: 'German Wirehaired Pointer' },
  { id: '3JQT5V96', name: 'Giant Schnauzer' },
  { id: '3JQT5V97', name: 'Glen Of Imaal Terrier' },
  { id: '3JQT5V98', name: 'Golden Labrador (hybrid)' },
  { id: '3JQT5V99', name: 'Golden Retriever' },
  { id: '3JQT5VA5', name: 'Goldendoodle' },
  { id: '3JQT5VA6', name: 'Gordon Setter' },
  { id: '3JQT5VA7', name: 'Gran Mastin de Borinquen' },
  { id: '3JQT5VA8', name: 'Grand Basset Griffon Vendeen' },
  { id: '3JQT5VA9', name: 'Grand Bleu de Gascogne' },
  { id: '3JQT5VC5', name: 'Great Dane' },
  { id: 'MIXGRTDA', name: 'Great Dane Mix' },
  { id: '3L2QUOJ5', name: 'Great Pyrenean' },
  { id: '3JQT5VC6', name: 'Great Pyrenees' },
  { id: 'MIXGRTPY', name: 'Great Pyrenees Mix' },
  { id: '3JQT5VC7', name: 'Greater Swiss Mountain Dog' },
  { id: 'MIXGRTSM', name: 'Greater Swiss Mountain Dog Mix' },
  { id: '3JQT5VC8', name: 'Greenland Dog' },
  { id: '3JQT5VC9', name: 'Greyhound' },
  { id: 'MIXGREYH', name: 'Greyhound Mix' },
  { id: '3JQT5VD6', name: 'Griffon Bruxellois' },
  { id: '3JQT5VD7', name: 'Groenendael' },
  { id: '3JQT5VD8', name: 'Hamiltonstovare' },
  { id: '3JQT5VD9', name: 'Harrier' },
  { id: '3JQT5VE5', name: 'Havanese' },
  { id: 'MIXHAVAN', name: 'Havanese Mix' },
  { id: 'HOKKAIDO', name: 'Hokkaido' },
  { id: '3JQT5VE6', name: 'Hovawart' },
  { id: '3JQT5VE7', name: 'Hungarian Kuvasz' },
  { id: '3JQT5VE8', name: 'Hungarian Puli' },
  { id: '3JQT5VE9', name: 'Hungarian Pumi' },
  { id: '3JQT5VF5', name: 'Hungarian Sheepdog' },
  { id: '3JQT5VF6', name: 'Hungarian Vizsla' },
  { id: '3JQT5VF7', name: 'Hungarian Wire Haired Vizsla' },
  { id: '3JQT5VF8', name: 'Ibizan Hound' },
  { id: '3JQT5VF9', name: 'Icelandic Sheepdog' },
  { id: '3JQT5VG5', name: 'Inca Hairless Dog' },
  { id: '3JQT5VG6', name: 'Inca Orchid' },
  { id: 'INDIANPD', name: 'Indian Pariah Dog' },
  { id: '3JQT5VG7', name: 'Irish Red and White Setter' },
  { id: '3JQT5VG8', name: 'Irish Setter' },
  { id: 'MIXIRISH', name: 'Irish Setter Mix' },
  { id: '3JQT5VG9', name: 'Irish Staffordshire Bull Terrier' },
  { id: '3JQT5VH5', name: 'Irish Terrier' },
  { id: '3JQT5VH6', name: 'Irish Water Spaniel' },
  { id: '3JQT5VH7', name: 'Irish Wolfhound' },
  { id: 'ISTRIANS', name: 'Istrian Shorthaired Hound' },
  { id: '3JQT5VH8', name: 'Italian Greyhound' },
  { id: 'MIXITALI', name: 'Italian Greyhound Mix' },
  { id: '3JQT5VH9', name: 'Jack Russell Terrier' },
  { id: 'MIXJACK', name: 'Jack Russell Terrier Mix' },
  { id: '3JQT5VJ5', name: 'Japanese Chin' },
  { id: 'MIXJAPAN', name: 'Japanese Chin Mix' },
  { id: '3JQT5VJ6', name: 'Japanese Spitz' },
  { id: '3JQT5VJ7', name: 'Japanese Terrier' },
  { id: 'JINDO', name: 'Jindo' },
  { id: '3JQT5VJ8', name: 'Kai Dog' },
  { id: '3JQT5VJ9', name: 'Kangal Dog' },
  { id: '3JQT5VK5', name: 'Karabash' },
  { id: '3JQT5VK6', name: 'Karelian Bear Dog' },
  { id: '3JQT5VK7', name: 'Keeshond' },
  { id: '3JQT5VK8', name: 'Kelpie' },
  { id: '3JQT5VK9', name: 'Kerry Blue Terrier' },
  { id: '3JQT5VL5', name: 'King Charles Spaniel' },
  { id: '3JQT5VL6', name: 'King Shepherd' },
  { id: 'KISHUKEN', name: 'Kishu Inu' },
  { id: '3JQT5VL7', name: 'Komondor' },
  { id: '3JQT5VL8', name: 'Kooikerhondje' },
  { id: '3JQT5VL9', name: 'Koolie' },
  { id: '3JQT5VM5', name: 'Korean Jindo' },
  { id: '3JQT5VM6', name: 'Kuvasz' },
  { id: '3JQT5VM7', name: 'Kyi-Leo' },
  { id: '3JQT5VM8', name: 'Labradoodle' },
  { id: '3JQT5VM9', name: 'Labrador Husky' },
  { id: '3L2QUUI4', name: 'Labrador Mix' },
  { id: '3L024PR2', name: 'Labrador Retriever' },
  { id: '3JQT5VN5', name: 'Labrador Retriever - Black' },
  { id: '3JQT5VN6', name: 'Labrador Retriever - Chocolate' },
  { id: '3JQT5VN7', name: 'Labrador Retriever - Yellow' },
  { id: '3JQT5VN8', name: 'Laekenois' },
  { id: '3JQT5VN9', name: 'Lagotto Romagnolo' },
  { id: '3JQT5VO5', name: 'Lakeland Terrier' },
  { id: '3JQT5VO6', name: 'Lancashire Heeler' },
  { id: '3JQT5VO7', name: 'Landseer' },
  { id: '3JQT5VO8', name: 'Lapinporokoira' },
  { id: '3JQT5VO9', name: 'Large Munsterlander' },
  { id: '3JQT5VP5', name: 'Leonberger' },
  { id: '3JQT5VP6', name: 'Lhasa Apso' },
  { id: 'MIXLHASA', name: 'Lhasa Apso Mix' },
  { id: 'Llewell', name: 'Llewellin Setter' },
  { id: '3JQT5VP7', name: 'Louisiana Catahoula Leopard Dog' },
  { id: '3JQT5VP8', name: 'Lowchen' },
  { id: '3JQT5VP9', name: 'Lucas Terrier' },
  { id: '3JQT5VR5', name: 'Lurcher' },
  { id: '3JQT5VR6', name: 'Malamute Husky' },
  { id: 'MIXMALAM', name: 'Malamute Mix' },
  { id: '3JQT5VR7', name: 'Malinois' },
  { id: '3JQT5VR8', name: 'Malt-A-Poo' },
  { id: '3JQT5VR9', name: 'Maltese' },
  { id: 'MIXMALTE', name: 'Maltese Mix' },
  { id: '3JQT5VS5', name: 'Manchester Terrier' },
  { id: '3JQT5VS6', name: 'Maremma Sheepdog' },
  { id: '3JQT5VS7', name: 'Mastiff' },
  { id: 'MIXMASTI', name: 'Mastiff Mix' },
  { id: '3JQT5VS9', name: 'Mexican Hairless Crested' },
  { id: '3JQT5VS8', name: 'Mexican Hairless Dog' },
  { id: '3JQT5VT5', name: 'Miki' },
  { id: 'MINIGOLD', name: 'Mini Goldendoodle' },
  { id: '3L2QV4J1', name: 'Miniature Dachshund' },
  { id: '3JQT5VT6', name: 'Miniature Pinscher' },
  { id: 'MIXMINIA', name: 'Miniature Pinscher Mix' },
  { id: '3L2QVAF7', name: 'Miniature Poodle' },
  { id: '3L2QUKB0', name: 'Miniature Schnauzer' },
  { id: '3JQT5VT7', name: 'Mioritic Sheepdog' },
  { id: '3JQT5U06', name: 'Mixed Breed Large (71lb +)' },
  { id: '3JQT5U05', name: 'Mixed Breed Medium (23 - 70lb)' },
  { id: '3JQT5TU9', name: 'Mixed Breed Small ( up to 22lb )' },
  { id: 'MOUNTCUR', name: 'Mountain Cur' },
  { id: 'MOUNTFEI', name: 'Mountain Feist' },
  { id: '3JQT5VU6', name: 'Mudi' },
  { id: 'NATIVAME', name: 'Native American Indian Dog' },
  { id: '3JQT5VU7', name: 'Neapolitan Mastiff' },
  { id: '3JQT5VU8', name: 'Nebolish Mastiff' },
  { id: '3JQT5VU9', name: 'New Zealand Huntaway (Sheepdog)' },
  { id: '3JQT5VV5', name: 'Newfoundland' },
  { id: 'MIXNEWFO', name: 'Newfoundland Mix' },
  { id: '3JQT5VV6', name: 'Nippon Terrier' },
  { id: '3JQT5VV7', name: 'Norfolk Terrier' },
  { id: '3JQT5VV8', name: 'Northern Inuit Dog' },
  { id: '3JQT5VV9', name: 'Norwegian Buhund' },
  { id: '3JQT6005', name: 'Norwegian Elkhound' },
  { id: '3JQT6006', name: 'Norwegian Lundehund' },
  { id: '3JQT6007', name: 'Norwich Terrier' },
  { id: '3JQT6008', name: 'Nova Scotia Duck Tolling Retriever' },
  { id: '3JQT6009', name: 'Old English Mastiff' },
  { id: '3JQT6025', name: 'Old English Sheepdog' },
  { id: 'MIXOLD E', name: 'Old English Sheepdog Mix' },
  { id: '3JQT60A6', name: 'Olde English Bulldogge' },
  { id: '3JQT60T4', name: 'Olde Victorian Bulldogge' },
  { id: '3JQT60V2', name: 'Ori Pei' },
  { id: '3JQT6105', name: 'Otterhound' },
  { id: '3JQT6147', name: 'Papillon' },
  { id: 'MIXPAPIL', name: 'Papillon Mix' },
  { id: '3JQT6148', name: 'Parson Jack Russell Terrier' },
  { id: '3JQT6149', name: 'Patterdale Terrier' },
  { id: '3JQT6155', name: 'Peek-a-poo' },
  { id: '3JQT6156', name: 'Pekingese' },
  { id: 'MIXPEKIN', name: 'Pekingese Mix' },
  { id: '3JQT6157', name: 'Pembroke Welsh Corgi' },
  { id: '3JQT6158', name: 'Perro de Presa Mallorquin' },
  { id: '3JQT6159', name: 'Peruvian Inca Orchid' },
  { id: '3JQT6175', name: 'Petit Basset Griffon Vendeen' },
  { id: '3JQT5VD5', name: 'Petit Brabancon' },
  { id: '3JQT6176', name: 'Pharaoh Hound' },
  { id: '3JQT6177', name: 'Pit Bull' },
  { id: 'MIXPITBU', name: 'Pit Bull Mix' },
  { id: '3JQT6178', name: 'Plott Hound' },
  { id: '3JQT6179', name: 'Pointer' },
  { id: '3JQT6185', name: 'Polish Lowland Sheepdog' },
  { id: '3JQT6186', name: 'Polish Tatra Sheepdog' },
  { id: '3JQT6187', name: 'Pomeranian' },
  { id: 'MIXPOMER', name: 'Pomeranian Mix' },
  { id: '3L025DK2', name: 'Poodle' },
  { id: '3JQT6188', name: 'Poodle - Giant' },
  { id: '3JQT6189', name: 'Poodle - Miniature' },
  { id: '3JQT6195', name: 'Poodle - Standard' },
  { id: '3JQT6196', name: 'Poodle - Teacup' },
  { id: '3JQT6197', name: 'Poodle - Toy' },
  { id: 'MIXPOODL', name: 'Poodle Mix' },
  { id: '3JQT6198', name: 'Porcelaine' },
  { id: 'PORTMAST', name: 'Portuguese Mastiff (Rafeiro Do Alentejo)' },
  { id: '3JQT6199', name: 'Portuguese Podengo' },
  { id: 'PORTPOIN', name: 'Portuguese Pointer' },
  { id: '3JQT61A5', name: 'Portuguese Water Dog' },
  { id: 'MIXPORTU', name: 'Portuguese Water Dog Mix' },
  { id: '3JQT61A6', name: 'Presa Canario' },
  { id: '3JQT61A7', name: 'Pudelpointer' },
  { id: '3JQT61A8', name: 'Pug' },
  { id: 'MIXPUGXX', name: 'Pug Mix' },
  { id: '3JQT61A9', name: 'Puggle' },
  { id: '3JQT61B5', name: 'Puli' },
  { id: '3JQT61B6', name: 'Pumi' },
  { id: '3JQT61B7', name: 'Pyrenean Mastiff' },
  { id: '3JQT61B8', name: 'Pyrenean Mountain Dog' },
  { id: '3JQT61B9', name: 'Pyrenean Shepherd' },
  { id: '3LHJR1S1', name: 'Queensland Heeler' },
  { id: '3JQT61C5', name: 'Rat Terrier' },
  { id: 'MIXRETRI', name: 'Retriever Mix' },
  { id: '3JQT61C6', name: 'Rhodesian Ridgeback' },
  { id: 'MIXRHODE', name: 'Rhodesian Ridgeback Mix' },
  { id: '3JQT61C7', name: 'Rottweiler' },
  { id: 'MIXROTTW', name: 'Rottweiler Mix' },
  { id: '3JQT61C8', name: 'Rough Collie' },
  { id: '3JQT61C9', name: 'Saarlooswolfhond' },
  { id: '3JQT61E5', name: 'Saint Bernard' },
  { id: 'STBERNDM', name: 'Saint Bernard mix' },
  { id: '3JQT61E6', name: 'Saluki' },
  { id: '3JQT61E7', name: 'Samoyed' },
  { id: 'MIXSAMOY', name: 'Samoyed Mix' },
  { id: 'SARPLANI', name: 'Sarplaninac' },
  { id: '3JQT61E8', name: 'Schapendoes' },
  { id: 'SCHILLHD', name: 'Schiller Hound' },
  { id: 'SCHILLER', name: 'Schillerstovare' },
  { id: '3JQT61E9', name: 'Schipperke' },
  { id: '3L025JG8', name: 'Schnauzer' },
  { id: '3JQT61F5', name: 'Schnauzer - giant' },
  { id: '3JQT61F6', name: 'Schnauzer - miniature' },
  { id: '3JQT61F7', name: 'Schnauzer - standard' },
  { id: 'MIXSCHNA', name: 'Schnauzer Mix' },
  { id: '3JQT61F9', name: 'Schnoodle' },
  { id: '3JQT61G5', name: 'Scottish Deerhound' },
  { id: '3JQT61G6', name: 'Scottish Terrier' },
  { id: '3JQT61G7', name: 'Sealyham Terrier' },
  { id: '3JQT61G8', name: 'Segugio Italiano' },
  { id: '3JQT61G9', name: 'Shar-pei' },
  { id: '3L2QV7L4', name: 'Shar-pei Mix' },
  { id: '3JQT61H5', name: 'Shetland Sheepdog' },
  { id: 'MIXSHETL', name: 'Shetland Sheepdog Mix' },
  { id: '3JQT61H6', name: 'Shiba Inu' },
  { id: 'MIXSHIBA', name: 'Shiba Inu Mix' },
  { id: '3JQT61H7', name: 'Shih Tzu' },
  { id: 'MIXSHIHT', name: 'Shih Tzu Mix' },
  { id: '3JQT61H8', name: 'Shikoku' },
  { id: '3JQT61H9', name: 'Shiloh Shepherd' },
  { id: 'MIXSHILO', name: 'Shiloh Shepherd Mix' },
  { id: '3JQT61I5', name: 'Siberian Husky' },
  { id: 'MIXSIBER', name: 'Siberian Husky Mix' },
  { id: 'SILKWIND', name: 'Silken Windhound' },
  { id: '3JQT61I6', name: 'Silky Terrier' },
  { id: '3JQT61I7', name: 'Skye Terrier' },
  { id: '3JQT61I8', name: 'Sloughi' },
  { id: '3JQT61I9', name: 'Small Munsterlander' },
  { id: '3JQT61J5', name: 'Smooth Collie' },
  { id: '3JQT61J6', name: 'Smooth Fox Terrier' },
  { id: '3JQT61J7', name: 'Soft Coated Wheaten Terrier' },
  { id: 'MIXSPANI', name: 'Spaniel Mix' },
  { id: '3JQT61J8', name: 'Spanish Bulldog' },
  { id: '3JQT61J9', name: 'Spanish Mastiff' },
  { id: '3JQT61L5', name: 'Spanish Water Dog' },
  { id: '3JQT61L6', name: 'Spinone italiano' },
  { id: '3JQT61L7', name: 'Spitz' },
  { id: 'STABYHOU', name: 'Stabyhoun (Stabij)' },
  { id: '3JQT61L8', name: 'Staffordshire Bull Terrier' },
  { id: 'MIXSTAFF', name: 'Staffordshire Bull Terrier Mix' },
  { id: '3JQT61L9', name: 'Staghound' },
  { id: '3JQT61M5', name: 'Sussex Spaniel' },
  { id: '3JQT61M6', name: 'Swedish Elkhound' },
  { id: '3JQT61M7', name: 'Swedish Lapphund' },
  { id: '3JQT61M8', name: 'Swedish Vallhund' },
  { id: 'TIAWANND', name: 'Taiwanese Native Dog' },
  { id: 'TASKASAG', name: 'Taskasago Dog' },
  { id: '3L2QU7D2', name: 'Terrier Mix' },
  { id: '3JQT61M9', name: 'Tervuren' },
  { id: '3JQT61N5', name: 'Thai Ridgeback' },
  { id: '3JQT61N6', name: 'Tibetan KyiApso' },
  { id: '3JQT61N7', name: 'Tibetan Mastiff' },
  { id: '3JQT61N8', name: 'Tibetan Spaniel' },
  { id: '3JQT61N9', name: 'Tibetan Terrier' },
  { id: 'TORNJAK', name: 'Tornjak' },
  { id: '3JQT61O5', name: 'Tosa Inu' },
  { id: '3JQT61O6', name: 'Toy Fox Terrier' },
  { id: '3JQT61O7', name: 'Toy Terrier' },
  { id: 'TRANSYLV', name: 'Transylvanian Hound' },
  { id: 'TREETENN', name: 'Treeing Tennessee Brindle' },
  { id: '3M67UNT5', name: 'Treeing Walker Coonhound' },
  { id: 'Victoria', name: 'Victorian Bulldog' },
  { id: '3JQT61O8', name: 'Vizsla' },
  { id: 'MIXVIZSL', name: 'Vizsla Mix' },
  { id: '3JQT61O9', name: 'Volpino Italiano' },
  { id: '3JQT61P5', name: 'Weimaraner' },
  { id: 'MIXWEIMA', name: 'Weimaraner Mix' },
  { id: '3L3M9RD9', name: 'Welsh Corgi' },
  { id: '3JQT61P6', name: 'Welsh Corgi - Cardigan' },
  { id: '3JQT61P7', name: 'Welsh Corgi - Pembroke' },
  { id: 'WELSPR', name: 'Welsh Springer Spaniel' },
  { id: '3JQT61P8', name: 'Welsh Terrier' },
  { id: '3JQT61P9', name: 'West Highland White Terrier' },
  { id: '3JQT61Q5', name: 'Wheaten Terrier' },
  { id: 'MIXWHEAT', name: 'Wheaten Terrier Mix' },
  { id: '3JQT61Q6', name: 'Whippet' },
  { id: 'MIXWHIPP', name: 'Whippet Mix' },
  { id: 'WHSWISSS', name: 'White Swiss Shepherd' },
  { id: '3JQT61Q7', name: 'Wirehaired Fox Terrier' },
  { id: '3JQT61Q8', name: 'Wirehaired Pointing Griffon' },
  { id: '3JQT61Q9', name: 'Wirehaired Vizsla' },
  { id: '3JQT61R5', name: 'Xoloitzcuintli - Mexican Hairless Dog' },
  { id: '3JQT61R6', name: 'Yorkie-Poo' },
  { id: '3JQT61R7', name: 'Yorkshire Terrier' },
  { id: 'MIXYORKS', name: 'Yorkshire Terrier Mix' },
];

const CAT: Breed[] = [
  { id: '3JQT45O9', name: 'Abyssinian' },
  { id: '3JQT45P5', name: 'American Bobtail' },
  { id: '3JQT45P6', name: 'American Curl' },
  { id: '3KVMA9K3', name: 'American Curl Shorthair' },
  { id: '3JQT45P7', name: 'American Keuda' },
  { id: '3JQT45P8', name: 'American Longhair' },
  { id: '3JQT45P9', name: 'American Shorthair (purebred)' },
  { id: '3JQT45Q5', name: 'American Wirehair' },
  { id: '3JQT45Q6', name: 'Angora' },
  { id: 'AUSTMIST', name: 'Australian Mist' },
  { id: '3JQT45Q7', name: 'Balinese' },
  { id: '3JQT45Q8', name: 'Bengal' },
  { id: '3KVMAJR6', name: 'Bengalese' },
  { id: '3JQT45Q9', name: 'Birman' },
  { id: '3JQT45R5', name: 'Bombay' },
  { id: 'BRAZSHOR', name: 'Brazilian Shorthair' },
  { id: '3JQT45R6', name: 'British Shorthair' },
  { id: '3JQT45R7', name: 'Burmese' },
  { id: '3JQT45R8', name: 'Burmilla' },
  { id: '3KVMALO6', name: 'Calico' },
  { id: '3JQT45R9', name: 'California Spangled Cat' },
  { id: '3KVMAMN9', name: 'Cameo Longhair' },
  { id: '3JQT45S5', name: 'Chantilly/Tiffany' },
  { id: '3JQT45S6', name: 'Chartreux' },
  { id: '3KVMAO49', name: 'Chausie' },
  { id: '3KVMAPA9', name: 'Chinchilla' },
  { id: '3KVMAQI2', name: 'Colorpoint' },
  { id: '3KVMARK5', name: 'Colorpoint Longhair' },
  { id: '3JQT45S7', name: 'Colorpoint Shorthair' },
  { id: '3JQT45S8', name: 'Cornish Rex' },
  { id: '3KVMAT24', name: 'Cymric' },
  { id: '3JQT45S9', name: 'Devon Rex' },
  { id: '3JQT45U5', name: 'Domestic Longhair' },
  { id: '3JQT45U6', name: 'Domestic Mediumhair' },
  { id: '3JQT45U7', name: 'Domestic Shorthair' },
  { id: 'DONSKOY', name: 'Donskoy' },
  { id: '3JQT45U8', name: 'Egyptian Mau' },
  { id: '3KVMB0P9', name: 'European Burmese' },
  { id: '3KVMB205', name: 'European Shorthair' },
  { id: '3KVMB3V2', name: 'Exotic' },
  { id: '3JQT45U9', name: 'Exotic Longhair' },
  { id: '3JQT45V5', name: 'Exotic Shorthair' },
  { id: '3JQT45V6', name: 'Feral' },
  { id: 'GERMANRX', name: 'German Rex' },
  { id: '3JQT45V7', name: 'Havana Brown' },
  { id: '3KVMB542', name: 'Highland Fold' },
  { id: 'HIGHLYNX', name: 'Highland Lynx' },
  { id: '3JQT45V8', name: 'Himalayan' },
  { id: '3KVMB6C0', name: 'Himalayan Blue Point' },
  { id: '3KVMB824', name: 'Himalayan Flame Point' },
  { id: '3KVMBAK3', name: 'Himalayan Lilac Point' },
  { id: '3KVMBBU2', name: 'Himalayan Seal Point' },
  { id: '3JQT45V9', name: 'Japanese Bobtail' },
  { id: '3JQT4605', name: 'Javanese' },
  { id: '3JQT4606', name: 'Kashmir' },
  { id: '3JQT4607', name: 'Korat' },
  { id: '3JQT4608', name: 'La Perm' },
  { id: 'LYKOI', name: 'Lykoi' },
  { id: '3JQT4609', name: 'Maine Coon' },
  { id: '3JQT4615', name: 'Manx' },
  { id: '3JQT4616', name: 'Manx Longhair' },
  { id: '3KVMBEO4', name: 'Moggie' },
  { id: '3JQT4617', name: 'Munchkin' },
  { id: '3JQT4618', name: 'Nebelung' },
  { id: '3KVMBFR7', name: 'Nibelung' },
  { id: '3JQT4619', name: 'Norwegian Forest Cat' },
  { id: '3JQT4625', name: 'Ocicat' },
  { id: '3KVMBIM1', name: 'Oriental' },
  { id: '3KVMBK78', name: 'Oriental Colorpoint' },
  { id: '3KVMBLE0', name: 'Oriental Longhair' },
  { id: '3JQT4626', name: 'Oriental Shorthair' },
  { id: '3JQT4627', name: 'Persian' },
  { id: 'PETERBAL', name: 'Peterbald' },
  { id: '3KVMBMA4', name: 'Pinto' },
  { id: '3JQT4628', name: 'Pixie-Bob' },
  { id: '3JQT4629', name: 'RagaMuffin' },
  { id: '3JQT4635', name: 'Ragdoll' },
  { id: '3JQT4636', name: 'Russian Blue' },
  { id: '3JQT4637', name: 'Safari Cat' },
  { id: '3JQT4638', name: 'Savannah' },
  { id: '3JQT4639', name: 'Scottish Fold' },
  { id: '3KVMBN99', name: 'Scottish Fold Longhair' },
  { id: '3JQT4655', name: 'Selkirk Rex' },
  { id: '3KVMBOH9', name: 'Selkirk Rex Longhair' },
  { id: 'SERVEL', name: 'Servel' },
  { id: '3KVMBQF5', name: 'Seychellois' },
  { id: '3JQT4656', name: 'Siamese' },
  { id: '3JQT4657', name: 'Siberian' },
  { id: '3JQT4658', name: 'Singapura' },
  { id: '3JQT4659', name: 'Snowshoe' },
  { id: '3JQT4665', name: 'Sokoke' },
  { id: '3JQT4666', name: 'Somali' },
  { id: '3JQT4667', name: 'Sphynx' },
  { id: '3JQT4668', name: 'Sterling' },
  { id: '3KVMBRN8', name: 'Tabby' },
  { id: '3KVMBSS9', name: 'Tiffanie' },
  { id: '3JQT4669', name: 'Tonkinese' },
  { id: '3JQT4675', name: 'Turkish Angora' },
  { id: '3JQT4676', name: 'Turkish Van' },
  { id: '3JQT4677', name: 'York Chocolate' },
];

// Fetch's list arrives alphabetically, which buries the mixed-breed entries most
// shoppers want. Hoisting at export time keeps the source list in the order Fetch
// sends it, so a refreshed list drops in without re-sorting by hand.
function mixedBreedsFirst(breeds: Breed[]): Breed[] {
  const isMixed = (breed: Breed) => /mixed breed/i.test(breed.name);
  return [...breeds.filter(isMixed), ...breeds.filter((b) => !isMixed(b))];
}

export const BREEDS: Record<Species, Breed[]> = {
  DOG: mixedBreedsFirst(DOG),
  CAT: mixedBreedsFirst(CAT),
};
